// src/components/StarRating.js - Beautiful Star Rating Component
import React, { useState } from 'react';

const StarRating = ({ 
  rating = 0, 
  maxStars = 5, 
  size = '1.2rem', 
  interactive = false, 
  onRatingChange,
  showNumber = true 
}) => {
  const [hoverRating, setHoverRating] = useState(0);

  const handleStarClick = (starValue) => {
    if (interactive && onRatingChange) {
      onRatingChange(starValue);
    }
  };

  const handleStarHover = (starValue) => {
    if (interactive) {
      setHoverRating(starValue);
    }
  };

  const handleMouseLeave = () => {
    if (interactive) {
      setHoverRating(0);
    }
  };

  const getStarColor = (starIndex) => {
    const currentRating = interactive ? (hoverRating || rating) : rating;
    
    if (starIndex <= currentRating) {
      return '#FF6B35'; // Nigerian orange for filled stars
    } else if (starIndex - 0.5 <= currentRating) {
      return '#FFB366'; // Half-filled star
    } else {
      return '#E9ECEF'; // Empty star
    }
  };

  return (
    <div style={{ 
      display: 'flex', 
      alignItems: 'center', 
      gap: '0.3rem',
      cursor: interactive ? 'pointer' : 'default'
    }}>
      <div 
        style={{ display: 'flex', gap: '0.1rem' }}
        onMouseLeave={handleMouseLeave}
      >
        {[...Array(maxStars)].map((_, index) => {
          const starValue = index + 1;
          return (
            <span
              key={index}
              style={{
                fontSize: size,
                color: getStarColor(starValue),
                transition: 'all 0.2s ease',
                transform: interactive && hoverRating === starValue ? 'scale(1.2)' : 'scale(1)',
                filter: interactive ? 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))' : 'none'
              }}
              onClick={() => handleStarClick(starValue)}
              onMouseEnter={() => handleStarHover(starValue)}
            >
              ⭐
            </span>
          );
        })}
      </div>
      
      {showNumber && (
        <span style={{ 
          fontSize: '0.9rem', 
          color: 'var(--text-light)',
          fontWeight: '600',
          marginLeft: '0.5rem'
        }}>
          {rating > 0 ? rating.toFixed(1) : '0.0'}
        </span>
      )}
    </div>
  );
};

export default StarRating;